import { render, staticRenderFns } from "./StudentFormInfo.vue?vue&type=template&id=5809dbb2&scoped=true"
import script from "./StudentFormInfo.vue?vue&type=script&lang=ts"
export * from "./StudentFormInfo.vue?vue&type=script&lang=ts"
import style0 from "./StudentFormInfo.vue?vue&type=style&index=0&id=5809dbb2&prod&lang=scss&scoped=true"
import style1 from "./StudentFormInfo.vue?vue&type=style&index=1&id=5809dbb2&prod&lang=scss"
import style2 from "./StudentFormInfo.vue?vue&type=style&index=2&id=5809dbb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5809dbb2",
  null
  
)

export default component.exports